// extracted by mini-css-extract-plugin
export var header = "_sl-1";
export var maskBottom = "_sl-6";
export var maskMiddle = "_sl-7";
export var maskTop = "_sl-5";
export var root = "_sl-0";
export var scrollDownButton = "_sl-3";
export var scrollDownButtonHidden = "_sl-4";
export var viewport = "_sl-2";